// extracted by mini-css-extract-plugin
module.exports = {"customSigns":"CustomSigns_customSigns__1RpvT"};